ENV_URL='https://api.praoshealth.com'
ENV2_URL='https://api.praoshealth.com'
DOCUMENT_TAB_IFRAME_URL='https://professional-v2.praoshealth.com/iframe/documents'
ADMIN_DOCUMENT_TAB_IFRAME_URL='https://'
TASK_TAB_IFRAME_URL='https://professional-v2.praoshealth.com/iframe/tasks'
ADMIN_TASK_TAB_IFRAME_URL='https://'
WS_URL='wss://ws.praoshealth.com'
SB_URL='https://briefcase.praoshealth.com'
